module.exports = __webpack_public_path__ + "img/zhuhai-4.4de235e4.jpg";